import MyProfileContainer from "./MyProfileContainer";

export default MyProfileContainer;
